import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Paper, TextField } from '@material-ui/core';
import { ArrowDownward, ArrowUpward, HighlightOff } from '@material-ui/icons';
import { useAttachmentCardStyles } from './attachmentCardStyles';

const ImageAttachmentComponent = ({
  image,
  index,
  onChangeField,
  onMove,
  onRemoveAttachment,
  totalAttachments,
  urlPath,
}) => {
  const URL = process.env.REACT_APP_BACKEND_ENDPOINT;
  const classes = useAttachmentCardStyles();

  const [titolo, setTitolo] = useState(image.titolo || '');
  const [note, setNote] = useState(image.note || '');

  const isFirst = index === 0;
  const isLast = index === totalAttachments - 1;

  useEffect(() => {
    setTitolo(image.titolo || '');
    setNote(image.note || '');
  }, [image]);

  return (
    <div className={classes.gridElement}>
      <Paper className={classes.paper}>
        <div className={classes.card}>
          <div className={classes.mediaSection}>
            <img
              className={classes.img}
              alt="componente immagine"
              src={`${URL}${urlPath}${image.id}`}
            />
          </div>

          <div className={classes.contentSection}>
            <TextField
              className={classes.textField}
              label="Titolo"
              value={titolo}
              name="titolo"
              multiline
              rowsMax={2}
              onChange={(e) => setTitolo(e.target.value)}
              onBlur={() => onChangeField(titolo, index, 'titolo')}
            />
            <TextField
              className={classes.textField}
              label="Note"
              value={note}
              name="note"
              multiline
              rowsMax={2}
              onChange={(e) => setNote(e.target.value)}
              onBlur={() => onChangeField(note, index, 'note')}
            />
          </div>

          <div className={classes.actionsSection}>
            <IconButton
              color="primary"
              size="small"
              aria-label="Rimuovi allegato"
              onClick={() => onRemoveAttachment(image.id)}
            >
              <HighlightOff />
            </IconButton>
            <IconButton
              color="primary"
              size="small"
              aria-label="Sposta su"
              disabled={isFirst}
              onClick={() => onMove(index, index - 1)}
            >
              <ArrowUpward style={{ color: isFirst ? 'gray' : 'inherit' }} />
            </IconButton>
            <IconButton
              color="primary"
              size="small"
              aria-label="Sposta giù"
              disabled={isLast}
              onClick={() => onMove(index, index + 1)}
            >
              <ArrowDownward style={{ color: isLast ? 'gray' : 'inherit' }} />
            </IconButton>
          </div>
        </div>
      </Paper>
    </div>
  );
};

ImageAttachmentComponent.propTypes = {
  image: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onChangeField: PropTypes.func.isRequired,
  onMove: PropTypes.func.isRequired,
  onRemoveAttachment: PropTypes.func.isRequired,
  totalAttachments: PropTypes.number,
  urlPath: PropTypes.string.isRequired,
};

export default ImageAttachmentComponent;
